import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { FC } from 'react';

// flag-icons only ships ISO 3166 codes, so the fiscal codes used by EAS need an explicit mapping.
const FLAG_CODE_BY_COUNTRY_CODE: Record<string, string> = {
	XI: 'gb',
	EL: 'gr',
	UK: 'gb',
};

export type TCountryFlagProps = {
	countryCode: string;
	// flag-icons sizes the flag from the font size: the result is `height` tall and 1.333x as wide.
	height?: number;
	sx?: SxProps<Theme>;
};

export const CountryFlag: FC<TCountryFlagProps> = ({ countryCode, height = 12, sx = {} }) => {
	const code = String(countryCode ?? '')
		.trim()
		.toUpperCase();
	const flagCode = FLAG_CODE_BY_COUNTRY_CODE[code] ?? code.toLowerCase();

	return (
		<Box
			component="span"
			className={`fi fi-${flagCode}`}
			sx={{ fontSize: `${height}px`, flexShrink: 0, ...sx }}
		/>
	);
};
